import { ORDER_METHODS } from '../../../../../services/exports/Constants';

export default {
  order_methods: {
    [ORDER_METHODS.ON_SITE]: 'Ordinazione al tavolo',
    [ORDER_METHODS.PICKUP]: 'Ritiro',
    [ORDER_METHODS.DELIVERY]: 'Consegna',
  },
};
